import React from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';

import Container from '@mui/material/Container';

import Header from '../components/Header/Header';
import Footer from '../components/Footer';

import IssueRoutesContainer from './issuer/IssueRoutesContainer';
import ListRoutesContainer from './issuer/ListRoutesContainer';

import { connect } from 'react-redux';
import Loading from 'react-fullscreen-loading';
import Chat from '../pages/user/Messaging/Chat';

const IssuerRoutes = (props) => {
    let { path } = useRouteMatch();

    return (
        <>
            <Header
                type="investor"
                companyLogo={localStorage.getItem('company-logo')}
            />
            <Container
                className="main-container"
                sx={{
                    '@media (min-width: 1200px)': {
                        maxWidth: '1600px',
                        //minWidth: '1550px',
                    },
                }}
            >
                <Loading
                    loading={!props.profile.preferred_tabs}
                    background="#fff"
                    loaderColor="#3E9CD9"
                />
                {props.profile.preferred_tabs && (
                    <main>
                        <Switch>
                        <Route exact path={`${path}/`} >
                            <Redirect to={`${path}/issue`} />
                        </Route>
                            <Route
                                path={`${path}/issue`}
                                component={IssueRoutesContainer}
                            />

                            <Route
                                path={`${path}/list`}
                                component={ListRoutesContainer}
                            />
                            <Route path={`${path}/messages`} component={Chat} />
                            <Route
                                path={path}
                                component={IssueRoutesContainer}
                            />
                        </Switch>
                    </main>
                )}
                <Footer hideRelease={true} />
            </Container>
        </>
    );
};

const mapStateToProps = ({ profile }) => {
    return {
        profile: profile,
    };
};

export default connect(mapStateToProps, null)(IssuerRoutes);
